export default "__VITE_ASSET__5b68b5eb__"